export var ACTION;
(function (ACTION) {
    ACTION["GO_BACK"] = "GO_BACK";
    ACTION["NEED_HELP"] = "NEED_HELP";
    ACTION["SHORTFALL_REPAYMENT"] = "SHORTFALL_REPAYMENT";
    ACTION["SHORTFALL_WEB_REPAYMENT"] = "SHORTFALL_WEB_REPAYMENT";
    ACTION["SHORTFALL_RECOMENDED"] = "SHORTFALL_RECOMENDED";
    ACTION["NAVIGATE_TRANSACTION"] = "NAVIGATE_TRANSACTION";
    ACTION["BLANK_ACTION"] = "BLANK_ACTION";
    ACTION["CANCEL_ACTION"] = "CANCEL_ACTION";
    ACTION["LEAD_TO_SHORTFALL_PAYMENT"] = "LEAD_TO_SHORTFALL_PAYMENT";
})(ACTION || (ACTION = {}));
